module.exports = __webpack_public_path__ + "static/media/Picture74.2b5779df.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture74.PNG
// module id = 1538
// module chunks = 0